import { ArrowBack, ArrowForward } from '@mui/icons-material';
import { Fab } from '@mui/material';
import React from 'react';
import { ResponsiveContainer, StackedCarousel } from 'react-stacked-center-carousel';
import { Group } from '../Types/Types';

interface Props {
  items: any[],
  card: any,
  onActiveSlideChange: (activeSlide: number) => void,
}
function ResponsiveCarousel(props : Props) {
    const { items, card, onActiveSlideChange } = props;
    const ref = React.useRef<StackedCarousel>();

    return (
      <div style={{ width: "100%", position: "relative" }}>
        <ResponsiveContainer
          carouselRef={ref}
          render={(parentWidth, carouselRef) => {
            // If you want to use a ref to call the method of StackedCarousel, you cannot set the ref directly on the carousel component
            // This is because ResponsiveContainer will not render the carousel before its parent's width is determined
            // parentWidth is determined after your parent component mounts. Thus if you set the ref directly it will not work since the carousel is not rendered
            // Thus you need to pass your ref object to the ResponsiveContainer as the carouselRef prop and in your render function you will receive this ref object
            let currentVisibleSlide = 5;
            if (parentWidth <= 1440) currentVisibleSlide = 3;
            if (parentWidth <= 1080) currentVisibleSlide = 3;
            return (
              <StackedCarousel
                ref={carouselRef}
                slideComponent={card}
                slideWidth={parentWidth < 800 ? parentWidth - 100 : 750}
                carouselWidth={parentWidth}
                data={items}
                currentVisibleSlide={items.length + 1 < currentVisibleSlide ? 1 : currentVisibleSlide}
                maxVisibleSlide={items.length + 1 < currentVisibleSlide ? 1 : currentVisibleSlide}
                onActiveSlideChange={onActiveSlideChange ? (activeSlide) => onActiveSlideChange(activeSlide) : undefined}
                useGrabCursor
              />
            );
          }}
        />
        <>
          <Fab
            style={{ position: "absolute", top: "40%", left: 10, zIndex: 10 }}
            size="small"
            color="primary"
            onClick={() => {
              ref.current?.goBack();
            }}
            sx={{ borderRadius: '0.5em' }}
          >
            <ArrowBack />
          </Fab>
          <Fab
            style={{ position: "absolute", top: "40%", right: 10, zIndex: 10 }}
            size="small"
            color="primary"
            onClick={() => {
              ref.current?.goNext();
            }}
            sx={{ borderRadius: '0.5em' }}
          >
            <ArrowForward />
          </Fab>
        </>
      </div>
    );
  
}

export default ResponsiveCarousel;